import { useRef, useState } from "react";
import { useSSR, useTranslation } from "react-i18next";


const Policies = () => {

    const { t, i18n } = useTranslation();
    const service = useRef(null);
    const [pp, setpp] = useState(true);
    const [pp1, setpp1] = useState(true);




    return (

        <div className="politikaCont">
            <div className="pp">
                <h3 className={pp ? 'opener open' : 'opener'} onClick={() => { setpp(!pp) }}>{t('pp')} </h3>
                <div className={pp ? ' pp ' : ' pp hidden '}>
                    <p>{t('pp1')}</p>
                    <p><br /></p>
                    <p>{t('pp2')}</p>
                    <p>{t('pp3')} </p>
                    <p>{t('pp4')}</p>
                    <br></br>
                    <p> </p>
                    <p><strong>{t('pp5')} </strong></p>
                    <ul>
                        <li>{t('pp6')} </li>
                        <li>{t('pp7')} </li>
                        <li>
                            {t('pp8')}
                            {/* Įrankyje leidžiame naudotis dvejais klausimynais - vienas yra skirtas organizacijos atstovei/-ei, kitas yra skirtas darbuotojams. Abiejų klausimynų atsakymai agreguojami į bendrą balą ir pateikiami taip, kad Jūs galėtumėte įvertinti, kaip Jūsų kolektyve jaučiasi dirbantys asmenys, kokios jų patirtys, ir kiek Jūsų atstovaujama organizacija yra pasiruošusi užtikrinti atvirą ir įtraukią darbo aplinką. */}
                        </li>
                    </ul>
                    <br></br>
                    <p><strong>
                        {t('pp9')}
                        {/* Kokius duomenis mes renkame, saugome ir naudojame? */}
                    </strong></p>
                    <p>
                        {t('pp10')}
                        {/* Siekdami suteikti aukščiau nurodytas paslaugas, Jūs pateikiate, o mes saugome šią informaciją: */}
                    </p>
                    <table className='policiesTable' cellPadding={0} cellSpacing={0}>
                        <tbody>
                            <tr>
                                <td valign="middle">
                                    <p><strong>
                                        {t('pp11')}
                                        {/* Duomenų kategorija */}
                                    </strong></p>
                                </td>
                                <td valign="middle">
                                    <p><strong>
                                        {t('pp12')}
                                        {/* Duomenų tipas */}
                                    </strong></p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="middle">
                                    <p>{t('pp13')}
                                        {/* Privalomi registracijos duomenys (būtini registracijai Įrankyje įvykdyti) */}
                                    </p>
                                </td>
                                <td valign="middle">
                                    <ul>
                                        <li>{t('pp14')}
                                            {/* Vardas; */}
                                        </li>
                                        <li>{t('pp15')}
                                            {/* Pavardė; */}
                                        </li>
                                        <li>{t('pp16')}
                                            {/* El. pašto adresas; */}
                                        </li>
                                        <li>{t('pp17')}
                                            {/* Atstovaujamos organizacijos pavadinimas */}
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td valign="middle">
                                    <p>{t('pp18')}
                                        {/* Prisijungimo duomenys */}
                                    </p>
                                </td>
                                <td valign="middle">
                                    <p>{t('pp19')}
                                        {/* Unikalus Jūsų prieigos raktas, kuris sukuriamas, kai pirmą kartą užsiregistruojate Įrankyje. Šis prieigos raktas reikalingas tam, kad galėtumėte prisijungti prie paskyros, dalintis su darbuotojais apklausomis, pamatyti nuasmenintus apklausų rezultatus. */}
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="middle">
                                    <p>{t('pp20')}
                                        {/* Ryšių duomenys (Jums pasidalinus nuoroda į Įrankio klausimyną su darbuotojais) */}
                                    </p>
                                </td>
                                <td valign="middle">
                                    <p>{t('pp21')}
                                        {/* Atsakymai į klausimyno klausimus. */}
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p> </p>
                    <p> </p>
                    <p> </p>
                    <br></br>
                    <p><strong>{t('pp22')}</strong></p>
                    <p></p>
                    <p>
                        {/* Susikurdami paskyrą Įrankyje, Jūs pasirenkate prisijungimo slaptažodį. Nacionalinis kibernetinio saugumo centras rekomenduoja naudoti sudėtingus slaptažodžius, kurie yra ne trumpesni nei 12 simbolių ir sudaryti iš didžiųjų raidžių, mažųjų raidžių, skaitmenų bei specialiųjų simbolių. Rekomenduojama naudoti unikalų slaptažodį, kuris niekur kitur nenaudojamas. */}
                        {t('pp23')}
                    </p>
                    <p>
                        {/* Neatskleiskite savo paskyros slaptažodžio tretiesiems asmenims. Jeigu atskleisite savo slaptažodį ar bet kokią kitą paskyros informaciją kitiems asmenims, Jūs būsite atsakingas už visus veiksmus atliktus naudojantis Jūsų paskyra. */}
                        {t('pp24')}
                    </p>
                    <p>
                        {/* Jūsų slaptažodis yra prisijungimo prie Jūsų paskyros raktas. Mes Jūsų slaptažodžių nekaupiame. Prisijungę prie savo paskyros Jūs galite bet kuriuo metu keisti ir atnaujinti savo duomenis. Pamiršus slaptažodį galėsite susikurti naują. */}
                        {t('pp25')}
                    </p>

                    <p><br /></p>
                    <p><strong>
                        {t('pp26')}
                        {/* Kokiais tikslais ir kokiu teisiniu pagrindu tvarkome Jūsų asmens duomenis ir kiek laiko juos saugome? */}
                    </strong></p>
                    <table className="policiesTable" cellPadding={0} cellSpacing={0}>
                        <tbody>
                            <tr>
                                <td valign="middle">
                                    <p><strong>
                                        {t('pp27')}
                                        {/* Duomenų tvarkymo tikslas ir aplinkybės */}
                                    </strong></p>
                                </td>
                                <td valign="middle">
                                    <p><strong>{t('pp28')}
                                        {/* Tvarkomų duomenų kategorijos */}
                                    </strong></p>
                                </td>
                                <td valign="middle">
                                    <p><strong>{t('pp29')}
                                        {/* Duomenų tvarkymo teisinis pagrindas */}
                                    </strong></p>
                                </td>
                                <td valign="middle">
                                    <p><strong>{t('pp30')}
                                        {/* Duomenų saugojimo laikotarpis */}
                                    </strong></p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="middle">
                                    <p><strong>{t('pp31')}</strong></p>
                                </td>
                                <td valign="middle">
                                    <ul>
                                        <li>{t('pp32')}</li>
                                        <li>{t('pp33')}</li>
                                    </ul>
                                </td>
                                <td valign="middle">
                                    <p>{t('pp34')}</p>
                                    <p><br /></p>
                                </td>
                                <td valign="middle">
                                    <p>{t('pp35')}</p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="middle">
                                    <p><strong>{t('pp36')}</strong></p>
                                </td>
                                <td valign="middle">
                                    <ul>
                                        <li>{t('pp37')}</li>
                                        <li>{t('pp38')}</li>
                                    </ul>
                                </td>
                                <td valign="middle">
                                    <p>{t('pp39')}</p>
                                    <p><br /></p>
                                </td>
                                <td valign="middle">
                                    <p>{t('pp40')}</p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="middle">
                                    <p><strong>{t('pp41')}</strong><strong>          </strong></p>
                                </td>
                                <td valign="middle">
                                    <ul>
                                        <li>{t('pp42')}</li>
                                        <li>{t('pp43')}</li>
                                    </ul>
                                </td>
                                <td valign="middle">
                                    <p>{t('pp44')}</p>
                                </td>
                                <td valign="middle">
                                    <p>{t('pp45')}</p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="middle">
                                    <p><strong>{t('pp46')}</strong></p>
                                </td>
                                <td valign="middle">
                                    <ul>
                                        <li>{t('pp47')}</li>
                                    </ul>
                                </td>
                                <td valign="middle">
                                    <ul>
                                        <li>{t('pp48')}</li>
                                        <li>{t('pp49')}</li>
                                    </ul>
                                </td>
                                <td valign="middle">
                                    <p>{t('pp50')}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>{t('pp51')}</p>
                    <p><br /></p>
                    <p><strong>{t('pp52')}</strong></p>
                    <p>{t('pp53')}</p>
                    <ul>
                        <li>{t('pp54')}</li>
                        <li>{t('pp55')}<ul>
                            <li>{t('pp56')}</li>
                            <li>{t('pp57')}</li>
                        </ul>
                        </li>
                        <li>{t('pp58')}</li>
                        <li>{t('pp59')}</li>
                    </ul>
                    <br></br>
                    <p><strong>{t('pp60')}</strong></p>
                    <p>{t('pp61')}</p>
                    <ul>
                        <li><strong>{t('pp62')}</strong> {t('pp63')}</li>
                        <li><strong>{t('pp64')}</strong> {t('pp65')} </li>
                        <li><strong>{t('pp66')}</strong>{t('pp67')}</li>
                        <li><strong>{t('pp68')}</strong>{t('pp69')}</li>
                        <li><strong>{t('pp70')}</strong>{t('pp71')}</li>
                        <li><strong>{t('pp72')}</strong>{t('pp73')}</li>
                    </ul>
                    <p>{t('pp74')}</p>
                    <p><strong> </strong></p>
                    <br></br>
                    <p><strong>{t('pp75')}</strong></p>
                    <p>{t('pp76')}</p>
                </div>
            </div>
            <br></br>
            <div className="pt">
                <h3 className={pp1 ? 'opener open' : 'opener'} onClick={() => { setpp1(!pp1) }}>{t('pt')} </h3>
                <div className={pp1 ? ' pt ' : ' pt hidden '}>
                    
                    <p>{t('pp77')}</p>
                    <p><br /></p>
                    
                </div>

            </div>
        </div>
    )
}

export default Policies